<template>
  <div class="help-document">
    <header>
      <div class="title-box">
        <span class="title">帮助文档</span>
        <!-- 第一层添加按钮 -->
        <i class="iconfont icon-nav-quickly-add" @click="firstAdd()" v-if="funAuth.includes(52)"></i>
      </div>
    </header>
    <div class="content-bottom">
      <div class="pull-left menu-bar">
        <div class="aside-body">
          <!-- 第一层 -->
          <draggable v-model="allNodes" @update="dragMovedFirst()" :options="groundsList">
            <div v-for="(item, key) in allNodes" :key="key">
              <div class="parent-list-item" :class="item.checked?'groundsListchecked':''" @click="chooseGroup(item)">
                <div class="son-item-right">
                  <!-- 第二层添加按钮 -->
                  <i class="iconfont icon-nav-quickly-add hovers" @click="secondAdd(item,key)"></i>
                </div>
                <!-- 一级展开按钮 -->
                <span v-if="item.childMenuList.length > 0" @click.stop="showSonList(item,key,$event,'second')" class="dropdwonspan" :style="item.isshowSubList?'transform:rotate(0deg)':''"><i class=" iconfont icon-RectangleCopy"></i></span>
                <span>{{item.menu_name}}</span>
              </div>
              <!-- 第二层 -->
              <draggable v-model="item.childMenuList" @update="dragMovedSecond()" :options="{
                  animation: 200,
                  group: {name:'soneItem'+key, pull: true, put: true},
                  sort: true,
                  ghostClass: 'ghost',
                  filter: '.no-drag'
              }" class="son-list-box second-son-list-box" :style="item.isshowSubList?'height:'+(item.childMenuList.length*40)+'px':'height:0;'" :class="item.isshowSubList?'in':'out'">
                <div v-for="(v1, k1) in item.childMenuList" :key="k1">
                  <div class="son-list-item" @click="chooseGroup(v1,item)" :class="v1.checked?'groundsListchecked':''">
                    <div class="son-item-right">
                      <!-- 第三层添加按钮 -->
                      <span @click="thirdAdd(v1,key)"><i class="iconfont icon-nav-quickly-add hovers"></i></span>
                    </div>
                    <i class="icon-img-flex" :class="k1==item.childMenuList.length-1?'icon-img-border-last':'icon-img-border'"></i>
                    <!-- 二级展开按钮 -->
                    <span v-if="v1.childMenuList.length > 0" @click.stop="showSonList(v1,k1,$event,'third',key)" class="dropdwonspan" :style="v1.isshowSubList?'transform:rotate(0deg)':''"><i class=" iconfont icon-RectangleCopy"></i></span>
                    <span>{{v1.menu_name}}</span>
                  </div>
                  <!-- 第三层 -->
                  <draggable v-model="v1.childMenuList" @update="dragMovedThird()" :options="{
                    animation: 200,
                    group: {name:'soneItem1'+key+k1, pull: true, put: true},
                    sort: true,
                    ghostClass: 'ghost',
                    filter: '.no-drag'
                  }" class="son-list-box third-son-list-box" :style="{height:(v1.isshowSubList?v1.childMenuList.length*40+'px':'0'), borderLeft:(k1 < item.childMenuList.length - 1 ?'1px dashed #999':'0')}" :class="v1.isshowSubList?'in':'out'">
                    <div class="son-list-item" v-for="(v2, k2) in v1.childMenuList" @click="chooseGroup(v2,v1)" :key="k2" :class="v2.checked?'groundsListchecked':''">
                      <i class="icon-img-flex" :class="k2==v1.childMenuList.length-1?'icon-img-border-last':'icon-img-border'"></i>
                      <span>{{v2.menu_name}}</span>
                    </div>
                  </draggable>
                </div>
              </draggable>
            </div>
          </draggable>
        </div>
      </div>
      <div class="pull-right detail-bar">
        <div class="content-box">
          <div class="top-bar" v-if="currentDetail">
            <el-button size="small" type="info" plain @click="delDoc()" v-if="funAuth.includes(54)">删 除</el-button>
            <el-button size="small" type="primary" @click="openEdit()" v-if="funAuth.includes(53)">编 辑</el-button>
          </div>
          <!-- <div class="editor-content" v-if="currentDetail" v-html="currentDetail"></div> -->
          <div class="editor-content" v-if="currentDetail" v-html="initContent(currentDetail)"></div>
          <div v-else class="no-data">
            <span>暂无数据~</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <div class="mask n1" v-if="dialogAdd"></div>
    <transition name="slide">
      <!-- <help-document-create v-if="dialogAdd" theme='帮助' :parentId="parentId"></help-document-create> -->
      <help-document-create v-if="dialogAdd" :parentId="parentId"></help-document-create>
    </transition>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import helpDocumentCreate from './help-document-create.vue'
import {mapMutations} from 'vuex'
import mixin from '@/common/js/mixins.js'
export default {
  name: 'helpDocument', // 帮助文档组件
  components: {
    draggable,
    helpDocumentCreate
  },
  mixins: [mixin],
  data () {
    return {
      moduleId: 16, // 模块ID
      allNodes: [], // 分组和列表
      dialogAdd: false, // 新增弹窗
      parentId: '', // 父节点id（添加节点时传）
      currentMenuName: '', // 当前显示的菜单名
      currentDetail: '', // 当前显示的详情
      currentId: ''
    }
  },
  created () {
    // 获取菜单列表
    this.getMenuList()
  },
  mounted () {
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // 监听关闭弹窗(新增或编辑之后)
    this.$bus.off('closeAddNews')
    this.$bus.on('closeAddNews', res => {
      this.dialogAdd = false
      if (res === 'refreshList') {
        // 获取菜单列表（新增之后）
        this.getMenuList().then(() => {
          // 第一层新增
          if (this.parentId === '') {
            // 详情显示该节点的最后一条数据
            this.chooseGroup(this.allNodes[this.allNodes.length - 1])
            return false
          }
          this.allNodes.some((item, key) => {
            let flag = false
            // 第二层新增
            if (this.parentId === item.id) {
              // 详情显示该节点的最后一条数据
              this.chooseGroup(item.childMenuList[item.childMenuList.length - 1])
              item.isshowSubList = true
              this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
              return true
            }
            item.childMenuList.some(item2 => {
              // 第三层新增
              if (this.parentId === item2.id) {
                // 详情显示该节点的最后一条数据
                this.chooseGroup(item2.childMenuList[item2.childMenuList.length - 1])
                item.isshowSubList = true
                item2.isshowSubList = true
                this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
                // 此时要根据isshowSubList及item2.childMenuList来设置document.querySelectorAll('.second-son-list-box')[key].style.height
                this.setHeight(item, key)
                flag = true
                return true
              }
            })
            if (flag) {
              return true
            }
          })
        })
      } else if (res === 'edit') {
        // 获取最新菜单列表(编辑之后)
        this.getMenuList().then(() => {
          // 重新获取item，触发this.chooseGroup()
          let flag = false
          this.allNodes.some((item, key) => {
            // 第一层编辑
            if (this.currentId === item.id) {
              this.chooseGroup(item)
              return true
            } else {
              item.childMenuList.some(item2 => {
                // 第二层编辑
                if (this.currentId === item2.id) {
                  this.chooseGroup(item2)
                  item.isshowSubList = true
                  this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
                  flag = true
                  return true
                } else {
                  item2.childMenuList.some(item3 => {
                    // 第三层编辑
                    if (this.currentId === item3.id) {
                      this.chooseGroup(item3)
                      item.isshowSubList = true
                      item2.isshowSubList = true
                      this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
                      // 此时要根据isshowSubList及item2.childMenuList来设置document.querySelectorAll('.second-son-list-box')[key].style.height
                      this.setHeight(item, key)
                      flag = true
                      return true
                    }
                  })
                }
              })
            }
            if (flag) {
              return true
            }
          })
        })
      }
    })
  },
  methods: {
    // 锚点处理(避免更改路由)
    initContent (str) {
      let div = document.createElement('DIV')
      div.innerHTML = str
      let a = div.getElementsByTagName('a')
      for (let index = 0; index < a.length; index++) {
        // let hash = a[index].hash
        let hash = a[index].getAttribute('href')
        if (hash !== null && hash.substr(0, 1) === '#') {
          a[index].setAttribute('href', 'javascript:;')
          a[index].setAttribute('onclick', 'document.querySelector("[name=\'' + hash.substr(1) + '\']").scrollIntoView(true);')
        }
      }
      return div.innerHTML
    },
    ...mapMutations({
      setTheme: 'THEME' // 设置新增弹窗主题
    }),
    // 排序
    sort () {
      let obj = {
        'menu_type': 1,
        'dataList': this.allNodes
      }
      this.$http.swapMenuSort(obj).then(res => {
        this.$message({
          showClose: true,
          type: 'success',
          message: '操作成功!'
        })
      })
    },
    // 遍历allNodes.item,根据各个节点的isshowSubList,来设置second-son-list-box高度
    setHeight (item, key) {
      setTimeout(() => {
        let targetDom = document.querySelectorAll('.second-son-list-box')[key]
        if (item.isshowSubList) {
        // 2.遍历item.childMenuList判断isshowSubList
          let count = 0
          item.childMenuList.map((item2, index2) => {
            if (item2.isshowSubList) {
            // 3.统计item2的childMenuList.length 给合适高度
              count = item2.childMenuList.length + count
            }
          })
          // 此时要根据子元素的个数*40增加高度
          targetDom.style.height = (count * 40) + (item.childMenuList.length * 40) + 'px'
        }
      }, 0)
    },
    // 删除文档
    delDoc () {
      this.$confirm('是否继续删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteMenu({'id': this.currentId}).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '操作成功!'
          })
          /*
            // 删除后不关闭其他选项的逻辑 todo
            this.allNodes.some((item, key) => {
              if (this.currentId === item.id) {
                this.allNodes.splice(key, 1)
                return true
              } else {
                item.childMenuList.some((item2, key2) => {
                  if (this.currentId === item2.id) {
                    item.childMenuList.splice(key2, 1)
                    return true
                  } else {
                    item2.childMenuList.some((item3, key3) => {
                      if (this.currentId === item3.id) {
                        item2.childMenuList.splice(key3, 1)
                        return true
                      }
                    })
                  }
                })
              }
            })
            this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
            console.log(this.allNodes, 'allnodes')
            this.allNodes.map((item, index) => {
              let targetDom = document.querySelectorAll('.second-son-list-box')[index]
              if (item.isshowSubList) {
                // 2.遍历item.childMenuList判断isshowSubList
                let count = 0
                item.childMenuList.map((item2, index2) => {
                  if (item2.isshowSubList) {
                    // 3.统计item2的childMenuList.length 给合适高度
                    count = item2.childMenuList.length + count
                  }
                })
                // 此时要根据子元素的个数*40增加高度
                targetDom.style.height = (count * 40) + (item.childMenuList.length * 40) + 'px'
              }
            })
          **/
          // 刷新列表
          this.getMenuList().then(() => {
            // 删除之后父节点的展开按钮不能关闭
            this.allNodes.some((item, key) => {
              if (this.parentId === item.id) {
                item.isshowSubList = true
                this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
                return true
              } else {
                item.childMenuList.some(item2 => {
                  if (this.parentId === item2.id) {
                    item.isshowSubList = true
                    item2.isshowSubList = true
                    this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
                    // 此时要根据isshowSubList及item2.childMenuList来设置document.querySelectorAll('.second-son-list-box')[key].style.height
                    this.setHeight(item, key)
                    return true
                  }
                })
              }
            })
          })
          this.currentDetail = ''
          this.currentMenuName = ''
          this.currentId = ''
        })
      })
    },
    // 编辑打开
    openEdit () {
      this.setTheme('帮助')
      this.dialogAdd = true
      setTimeout(() => {
        this.$bus.emit('openEdit', this.currentMenuName, this.currentDetail, this.currentId)
      }, 0)
    },
    // 获取菜单
    getMenuList () {
      return new Promise((resolve) => {
        this.$http.queryMenuList({'menu_type': 1}).then(res => {
          this.allNodes = res.dataList
          // 初始化allNodes
          this.allNodesInit()
          resolve()
        })
      })
    },
    // 第一层级的拖拽回调
    dragMovedFirst (e) {
      this.sort()
      // 第一层级每次拖拽后都给对应的second-son-list-box设置合适的高度
      // 1.遍历this.allNodes判断isshowSubList
      this.allNodes.map((item, index) => {
        let targetDom = document.querySelectorAll('.second-son-list-box')[index]
        if (item.isshowSubList) {
          // 2.遍历item.childMenuList判断isshowSubList
          let count = 0
          item.childMenuList.map((item2, index2) => {
            if (item2.isshowSubList) {
              // 3.统计item2的childMenuList.length 给合适高度
              count = item2.childMenuList.length + count
            }
          })
          // 此时要根据子元素的个数*40增加高度
          targetDom.style.height = (count * 40) + (item.childMenuList.length * 40) + 'px'
        }
      })
    },
    dragMovedSecond () {
      this.sort()
    },
    dragMovedThird () {
      this.sort()
    },
    // 第一层添加按钮
    firstAdd (parentId) {
      this.parentId = ''
      this.setTheme('帮助')
      this.dialogAdd = true
    },
    // 第二层添加按钮
    secondAdd (item) {
      this.parentId = item.id
      this.setTheme('帮助')
      this.dialogAdd = true
    },
    // 第三层添加按钮
    thirdAdd (item, key) {
      this.parentId = item.id
      this.setTheme('帮助')
      this.dialogAdd = true
    },
    // 展开按钮
    showSonList (item, key, e, str, parentkey) {
      item.isshowSubList = !item.isshowSubList
      if (str === 'second') {
        // 如果第一级的开关按钮关闭，则子菜单的所有isshowSubList均关闭
        if (!item.isshowSubList) {
          item.childMenuList.map(function (val) {
            val.isshowSubList = false
          })
        }
        this.$set(this.allNodes, key, item)
      } else {
        this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
        // 根据allNodes.item的展开与否设置second-son-list-box高度
        let targetDom = document.querySelectorAll('.second-son-list-box')[parentkey]
        if (item.isshowSubList) {
          // 此时要根据子元素的个数*40增加高度
          let self = targetDom.style.height
          self = self.substring(0, self.lastIndexOf('px'))
          targetDom.style.height = (item.childMenuList.length * 40) + parseInt(self) + 'px'
        } else {
          // 闭合后则减去相应的高度
          let self = targetDom.style.height
          self = self.substring(0, self.lastIndexOf('px'))
          targetDom.style.height = (parseInt(self) - (item.childMenuList.length * 40)) + 'px'
        }
      }
    },
    // 初始化allNodes
    allNodesInit () {
      this.allNodes.map((v, k) => {
        v.checked = false
        v.isshowSubList = false
      })
    },
    // item点击选中
    chooseGroup (val, valParent) {
      this.currentDetail = val.content
      this.currentMenuName = val.menu_name
      this.currentId = val.id
      if (valParent && !this.dialogAdd) {
        this.parentId = valParent.id
      }
      // 选中状态checked复位
      this.allNodes.map((v, k) => {
        v.checked = false
        if (v.childMenuList && v.childMenuList.length > 0) {
          v.childMenuList.map((v1, k1) => {
            v1.checked = false
            if (v1.childMenuList && v1.childMenuList.length > 0) {
              v1.childMenuList.map((v2, k2) => {
                v2.checked = false
              })
            }
          })
        }
      })
      // 当前选中高亮
      val.checked = true
      this.$set(this.allNodes, this.allNodes.length - 1, this.allNodes[this.allNodes.length - 1])
    }
  },
  computed: {
    groundsList () {
      return {
        animation: 200,
        group: {name: 'aside', pull: true, put: true},
        sort: true,
        ghostClass: 'ghost',
        filter: '.no-drag'
      }
    }
  }
}
</script>
<style lang="scss">
.help-document {
  height: 100%;
  overflow: auto;
  .title-box {
    float: left;
    width: 200px;
    height: 100%;
    border-right: 1px solid #E8E8E8;
    >i {
      float: right;
      color: #999999;
      cursor: pointer;
      font-size: 22px;
      margin-right: 22px;
      &:hover {
        color: #1890FF;
      }
    }
  }
  .content-bottom {
    height: calc(100% - 60px);
    .menu-bar {
      width: 220px;
      height: 100%;
      border-right: 1px solid #E8E8E8;
      .aside-body{
        padding-top:10px;
        height: 100%;
        overflow-y: auto;
        >div{
          >div{
            >div.parent-list-item{
              height:40px;line-height: 40px;padding:0 10px;width:100%;position: relative;background:#fff;
              >span{
                color:#666666;display: inline-block;width:140px;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap
              }
              &:hover{cursor: pointer;background: #F4F6F7;}
              &:hover .hovers{
                visibility: visible;
              }
              >i.icon-xialaxuanxiang{
                float:left;margin-right:5px;font-size: 20px;
              }
              span.dropdwonspan{
                float:left;height:20px;width:20px;line-height:20px;text-align:center;background:#F6F6F6;border:1px solid #DCDCDC; transform: rotate(-90deg);
                margin:10px 10px 0 0;
              }
              span.dropdwonspan.isshowIcon{cursor:not-allowed;opacity: .5;}
              .son-item-right{
                position: absolute;
                right: 20px;
                >i.icon-gerenshezhi1{
                  float:right;position: relative;margin-left:10px;&:hover{cursor:pointer;>div.delDiv{display: block;}}
                  >div.delDiv{
                    position: absolute;top: 40px;width: 120px;left: -90px;max-height: 100px;background: #fff; z-index: 1000;text-align:left;display: none;
                    box-shadow: 2px -2px 4px 0 rgba(155,155,155,0.30), -2px 2px 4px 0 rgba(155,155,155,0.30);
                    >p{height: 40px;line-height: 40px;i{margin: 0 15px;}&:hover{color:#1890FF;background: #F2F2F2;i{color:#1890FF;}}}
                  }
                }
              }
            }
            >div.groundsListchecked{background: #F4F6F7;}
            .son-list-box{
              height:0;
            }
            .son-list-box.out{
              height:0;
              overflow: hidden;
              transition: height .1s linear;
            }
            .son-list-box.in{
              // overflow: hidden;
              transition: height .1s linear;
            }
            .third-son-list-box {
              margin-left: 30px;
            }
            .son-list-item{
              width:100%;display:flex;position: relative;
              .son-item-right{
                position: absolute;
                right: 20px;
                >i.icon-gerenshezhi1{
                  float:right;position: relative;margin-left:10px;&:hover{cursor:pointer;>div.delDiv{display: block;}}
                  >div.delDiv{
                    position: absolute;top: 40px;width: 120px;left: -90px;max-height: 100px;background: #fff; z-index: 1000;text-align:left;display: none;
                    box-shadow: 2px -2px 4px 0 rgba(155,155,155,0.30), -2px 2px 4px 0 rgba(155,155,155,0.30);
                    >p{height: 40px;line-height: 40px;i{margin: 0 15px;}&:hover{color:#1890FF;background: #F2F2F2;i{color:#1890FF;}}}
                  }
                }
              }
              &:hover{
                cursor: pointer;background: #F4F6F7;
              }
              &:hover .hovers{
                visibility: visible;
              }
              span{
                max-width: 105px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              padding-left:30px;display: flex;height:40px;line-height: 40px;
              .icon-img-flex{
                flex: 0 0 15px;
                height: 40px;
                margin: 0 5px 0 0;
                background-size: cover;
              }
              .icon-img-border{
                background: url('/static/images/icon_img_border.png') no-repeat center;
              }
              .icon-img-border-last{
                background: url('/static/images/icon_img_border_last.png') no-repeat center;
              }
              span.dropdwonspan{
                float:left;height:20px;width:20px;line-height:20px;text-align:center;background:#F6F6F6;border:1px solid #DCDCDC; transform: rotate(-90deg);
                margin:10px 10px 0 0;
              }
              span.dropdwonspan.isshowIcon{cursor:not-allowed;opacity: .5;}
              >.parent-list-item {
                height: 40px;
                line-height: 40px;
                width: 100%;
                position: relative;
                background: #fff;
              }
            }
            .son-list-item.groundsListchecked{background: #F4F6F7;}
          }
        }
        .hovers {
          visibility: hidden;
          &:hover {
            color: #1890FF;
          }
        }
      }
    }
    .detail-bar {
      width: calc(100% - 220px);
      height: 100%;
      .content-box {
        height: 100%;
        padding: 10px 20px;
        .top-bar {
          overflow: hidden;
          margin-bottom: 10px;
          .el-button {
            float: right;
            margin-left: 8px;
          }
        }
        .editor-content {
          height: calc(100% - 34px);
          overflow-y: auto;
          ul, ol {
            list-style: outside;
            margin-left: 20px;
          }
          li {
            list-style-type: inherit;
          }
          img {
            max-width: 100%;
          }
          [align='center'] {
              margin: 0 auto;
          }
          h1, h2, h3, h4, h5, h6 {
            font-weight: bold;
          }
        }
        .no-data {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          >span {
            font-size: 14px;
            color: #CCC;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/help/help-document.vue